export default "__VITE_ASSET__CJdn5P5b__"